import { Navigate, useParams } from 'react-router-dom';

const RedirectToCars: React.FC = () => {
  const { lang } = useParams<{ lang: string }>();
  return <Navigate to={`/${lang || 'fr'}/cars`} replace />;
};

export default RedirectToCars;
